import { render, staticRenderFns } from "./SidebarWrapper.vue?vue&type=template&id=36a1b348"
import script from "./SidebarWrapper.vue?vue&type=script&lang=js"
export * from "./SidebarWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports